import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "26",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M15.333 12.96a12.16 12.16 0 0 1 4.61-9.553 12.02 12.02 0 0 0-16.33 1.31C-.66 9.374-.66 16.55 3.614 21.205a12.02 12.02 0 0 0 16.33 1.308 12.156 12.156 0 0 1-4.61-9.553ZM38.445 21.545v-1.239h.222v-.253h-.592v.255h.233v1.24h.137v-.003Zm1.145 0v-1.53h-.182l-.21 1.054-.207-1.054h-.18v1.53h.136v-1.152l.195.99h.133l.192-.995v1.157h.123ZM39.478 12.96c0 4.652-2.64 8.894-6.797 10.928a12.007 12.007 0 0 1-12.736-1.377 12.179 12.179 0 0 0 4.612-9.551 12.18 12.18 0 0 0-4.612-9.552 12.01 12.01 0 0 1 12.736-1.373c4.16 2.032 6.798 6.276 6.798 10.926l-.001-.001Z" })
    ], -1)
  ])))
}
export default { render: render }